import BookingStartDateHtml from './templates/booking_start_date.html';

export function BookingDiaryCtrl (
  $compile,
  $rootScope,
  $scope,
  $state,
  $stateParams,
  $transitions,
  $translate,
  $uibModal,
  BookingDiary,
  bookingRequests,
  companyApi,
  dateParsing,
  groups,
  jobStatusTypes,
  messages,
  sessionObjAPI,
  settings,
  workshopAPI
) {

  settings.jobStatusTypes = jobStatusTypes;
  $scope.bookingRequests  = bookingRequests || 0;
  $scope.loaded           = true;
  $scope.session          = sessionObjAPI.base();
  $scope.settings         = settings;
  $scope.simpleView       = false;

  $scope.BookingDiary = new BookingDiary(settings, groups);
  $scope.Company      = companyApi;

  $scope.defaultView = $scope.BookingDiary.getDefaultView($stateParams.view);

  $scope.startJobsForDate = function() {
    $uibModal.open({
      controller : 'startJobsForDateCtrl',
      templateUrl: BookingStartDateHtml
    }).result;
  };

  $scope.catchDraggedEvent = function (event) {
    $scope.BookingDiary.updateBookedEvent(event)
    .then(() => {
      messages.show($translate.instant('JS_SPACE.MESSAGES.SAVED.EVENT'), 'success');
    })
    .catch(err => {
      messages.error(err);
    })
    .finally(() => {
      if ($scope.BookingDiary.isDayView()) {
        $state.reload();
      }
    });
  };

  $scope.catchDroppedJob = function (date, event, ui, resourceId) {
    $('#'+event.target.id).remove();
  };

  $scope.configureEventLayout = function ( event, element, view ) {
    $scope.BookingDiary.configureEventLayout(event, element, view);
  };

  $scope.createEvent = function () {
    $state.go('app.event', {
      date: $scope.BookingDiary.start.format('YYYY-MM-DD')
    });
  };

  $scope.viewDay = function (date) {
    $scope.BookingDiary.viewDay($scope.event, date);
  };

  $scope.eventRender = function (event, element, view) {
    const eventScope = $scope.$new(true);

    eventScope.event       = event;
    eventScope.jobStatuses = $scope.BookingDiary.jobStatusTypes;

    element.html($compile($scope.BookingDiary.getEventTemplate(event))(eventScope));
  };

  $scope.getEvents = function (start, end, timezone, callback) {
    $scope.BookingDiary.configureEvents(start, end, timezone, callback);
  };

  $scope.getStats = function () {
    workshopAPI.get('/event_times/stats_for_day', $scope.calendar.defaultDate)
    .then(data => {
      $scope.stats = angular.extend({}, $scope.stats, data[$scope.calendar.defaultDate]);
    })
    .catch(err => {
      messages.error(err);
    });
  };

  $scope.receiveDroppedEvent = function (event) {
    $scope.BookingDiary.bookEvent(event)
    .then(() => {
      $scope.BookingDiary.jobs = $scope.BookingDiary.jobs.filter(job => job.id !== event.id);

      messages.show($translate.instant('JS_SPACE.MESSAGES.SAVED.EVENT'), 'success');

      $scope.BookingDiary.buildRouteAndReload({
        includeDate       : true,
        mechanic          : $stateParams.mechanic,
        mechanicId        : $stateParams.mechanicId,
        viewSingleMechanic: $stateParams.viewSingleMechanic
      });
    })
    .catch(err => {
      $scope.BookingDiary.getUnassignedJobs($scope.BookingDiary.start);

      $rootScope.$broadcast('pg-tooltip-hide');

      messages.error(err);
    });
  };

  $scope.viewBookingRequests = function () {
    $state.go('app.bookings.requests');
  };

  $scope.viewRender = function (view) {
    $scope.BookingDiary.viewRender(view);
  };

  $scope.calendar = {
    allDayDefault       : false,
    allDaySlot          : false,
    columnFormat        : $scope.Company.company.language === 'en-us' ? 'ddd M/D': 'ddd D/M',
    contentHeight       : 'auto',
    dayClick            : $scope.viewDay,
    defaultDate         : $stateParams.date || dateParsing.todayWithUtcOffset(),
    defaultView         : $scope.defaultView,
    drop                : $scope.catchDroppedJob,
    droppable           : true,
    eventAfterRender    : $scope.configureEventLayout,
    eventBackgroundColor: 'transparent',
    eventDrop           : $scope.catchDraggedEvent,
    eventReceive        : $scope.receiveDroppedEvent,
    eventRender         : $scope.eventRender,
    events              : $scope.getEvents,
    eventTextColor      : 'transparent',
    firstDay            : 1,
    customButtons       : {
      todayCustom: {
        text: $translate.instant('GENERAL_SPACE.BOOKING_DAYS.TODAY'),
        click () {
          $scope.BookingDiary.buildRouteAndReload({
            date              : dateParsing.todayWithUtcOffset(),
            includeDate       : true,
            mechanic          : $stateParams.mechanic,
            mechanicId        : $stateParams.mechanicId,
            viewSingleMechanic: $stateParams.viewSingleMechanic
          });
        }
      }
    },
    header: {
      left  : 'title',
      center: '',
      right : 'month,agendaWeek,multiColAgendaDay,todayCustom,prev,next'
    },
    lazyFetching: true,
    maxTime     : $scope.BookingDiary.shopCloses || '18:00:00',
    minTime     : $scope.BookingDiary.shopOpens || '08:00:00',
    now         : $stateParams.date || dateParsing.todayWithUtcOffset(),
    slotDuration: '00:15:00',
    timeFormat  : '',
    timezone    : 'UTC',
    viewRender  : $scope.viewRender,
    views       : {
      agendaWeek: {
        editable    : true,
        slotDuration: '00:30:00'
      },
      multiColAgendaDay: {
        columnHeaders: $scope.BookingDiary.mechanicGroup.headerColumns || $scope.BookingDiary.mechanicGroup.names,
        duration     : { days: 1 },
        editable     : true,
        formatDate   : $scope.Company.company.language === 'en-us' ? 'mm/dd': 'dd/mm',
        numColumns   : $scope.BookingDiary.mechanicGroup.names.length,
        type         : 'multiColAgenda'
      }
    }
  };

  // moved call here from module for better UX.
  if ($stateParams.view === 'day') {
    $scope.getStats();
    $scope.BookingDiary.getUnassignedJobs($scope.calendar.defaultDate);
  }

  // day view header columns provide links to view
  // specific mechanics. This works with those links
  // because they cannot escape angular markup.
  $transitions.onRetain({ retained: 'app.booking-diary' }, () => {
    if ($stateParams.view === 'day' && $stateParams.mechanicId) {
      $state.reload();
    }
  });

  $rootScope.$broadcast('pg-tooltip-hide');

  // Some users are reporting that the tooltip will
  // not always disappear, even across pages. This
  // will watch the current url and when changed, fire
  // a $broadcast to hide the tooltip.
  $scope.$on('$destroy', () =>{
    $rootScope.$broadcast('pg-tooltip-hide');
  });

  $scope.$on('viewDay', ( evt, event, withMechanic ) => {
    $scope.BookingDiary.viewDay(event, undefined, withMechanic);

    $rootScope.$broadcast('pg-tooltip-hide');
  });
}
